export default defineAppConfig({
  seo: {
    title: 'Find 27,000 IFAs, Financial Advisers, Mortgage Brokers, Accountants & Bookkeepers',
    description: 'Connecting you with the UK’s biggest selection of financial advisers, mortgage brokers, accountants & bookkeepers, we’ve connected millions with the unbiased advice they need.',
  },
  links: {
    social: {
      instagram: '//www.instagram.com/unbiaseduk',
      x: '//x.com/unbiaseduk',
      facebook: '//www.facebook.com/unbiaseduk',
      linkedin: '//www.linkedin.com/company/unbiased-co-uk',
      linkedinPro: '//www.linkedin.com/groups/2679302/profile',
    },
  },
})
